// eslint-disable-next-line @typescript-eslint/ban-types
export const createUniqueNameObject = <T extends object, N extends keyof T>(
  curr: T,
  existedNames: string[],
  name: N,
  patcher?: (updated: T) => T,
) => {
  const existColumnName = existedNames.includes(curr[name] as unknown as string);

  if (existColumnName) {
    const existColumnNameParts = (curr[name] as unknown as string).split("_");
    const numericSuffixRaw = existColumnNameParts[existColumnNameParts.length - 1];
    const numericSuffix = +numericSuffixRaw + 1 || 1;

    const fixedObject: T = {
      ...curr,
      [name]: `${existColumnNameParts.join("_")}_${numericSuffix}`,
    };

    return createUniqueNameObject(patcher ? patcher(fixedObject) : fixedObject, existedNames, name, patcher);
  }

  return curr;
};
